import { runtime } from './runtime'

/** @public */
export function refreshPage() {
	runtime.refreshPage()
}
